import { styled } from '@mui/material/styles';
import Menu, { MenuProps } from '@mui/material/Menu';

export const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={1}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(() => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: '4px',
    minWidth: 220,
    '.menuItem': {
      color: '#4D4D4D',
      fontSize: '14px',
      lineHeight: '20px',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'center',
      height: '32px',
      paddingLeft: '16px',
      '&.active': {
        color: '#005AA9',
        background: '#F3F8FC',
      },
    },
    '& .MuiMenu-list': {
      padding: '0',
    },
    '& .MuiMenuItem-root': {
      paddingTop: '2px',
    },
  },
}));
